import * as React from "react";

const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className = "", ...props }, ref) => {
  const baseClasses =
    "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70";
  const classes = `${baseClasses} ${className}`.trim();

  return <label ref={ref} className={classes} {...props} />;
});
Label.displayName = "Label";

export default Label;
